import Dialog from '@mui/material/Dialog'

import { Button, Icon } from '../../../../UI'

const TestProcessWarning = ({ open, onClose, warningMessage }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <Icon name="warning-triangle" color="#f79009" width={180} height={180} />

        <h2 className="mt-[16px] text-xl font-bold text-primary-100 text-center">
          {warningMessage || 'Please complete the test in full-screen mode.'}
        </h2>

        <Button
          type="button"
          className="!p-0 w-full h-[44px] mt-[24px] font-semibold text-lg shadow-button-second"
          onClick={onClose}
        >
          Continue
        </Button>
      </div>
    </Dialog>
  )
}

export default TestProcessWarning
